<script>
    let clazz;
    export {clazz as class};
</script>

<main class={clazz}>
    <h1 class="font-title text-7xl text-gray-50 m-8">FOXBANK</h1>
</main>

<style>
	main{
        width:100%;
        height:80px;
        
        background: linear-gradient(90.12deg, rgba(38, 77, 89, 0.7) 19.7%, rgba(38, 77, 89, 0) 93.77%);
    }
</style>